__webpack_require__.p = "/Gauransh-Portfolio/";